import { createAsyncThunk } from  '@reduxjs/toolkit';
import axiosInterceptorInstance from './axiosInterceptorInstance';

export const validateStaff = createAsyncThunk(
    'staff/validate',
    async (pfNumber: string) => {
        try {
            const relativeUrl = `Staff/${pfNumber}`;
            const apiUrl = `/enquiry/?relativeUrl=${relativeUrl}`;
            const response = await axiosInterceptorInstance.get(apiUrl);
            return response.data;
        } catch (error) {
            return error;
        }
    }
)